import { render, staticRenderFns } from "./cargoHistory.vue?vue&type=template&id=6871b6d6&scoped=true&"
import script from "./cargoHistory.vue?vue&type=script&lang=js&"
export * from "./cargoHistory.vue?vue&type=script&lang=js&"
import style0 from "./cargoHistory.vue?vue&type=style&index=0&id=6871b6d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6871b6d6",
  null
  
)

export default component.exports